import React, { Component } from "react";
import Amplify, { Auth, Storage } from "aws-amplify";
import UserStorageManager from "../src/UserProject/UserStorageManager";
const db = {};

const loadProjects = async () => {
  const currentUserInfo = await Auth.currentUserInfo();
  const userMan = new UserStorageManager(Storage, currentUserInfo);
  Object.assign(db, await userMan.loadProjects());
  console.log("Load Projects", db);
};

const editProject = async projectData => {
  const currentUserInfo = await Auth.currentUserInfo();
  const userMan = new UserStorageManager(Storage, currentUserInfo);
  await userMan.editProject(projectData.projectKey, projectData);
  Object.assign(db, await userMan.loadProjects());
};

const removeProject = async projectData => {
  const currentUserInfo = await Auth.currentUserInfo();
  const userMan = new UserStorageManager(Storage, currentUserInfo);
  await userMan.removeProject(projectData);
  Object.assign(db, await userMan.loadProjects());
};

const context = React.createContext({
  dbMan: {
    loadProjects: loadProjects,
    editProject: editProject,
    removeProject: removeProject
  },
  db: {}
});
export default context;
